import i18n from "i18next";
import { CHANGE_LANGUAGE, LanguageActionTypes } from "./languageActions";

export interface LanguageState {
  language: "tw" | "cn";
  languageList: { name: string; code: string }[];
}

const defaultState: LanguageState = {
  language: "tw",
  languageList: [
    { name: "繁體中文", code: "tw" },
    { name: "簡體中文", code: "cn" },
  ],
};

export default (state = defaultState, action: LanguageActionTypes) => {
  switch (action.type) {
    case CHANGE_LANGUAGE:
      i18n.changeLanguage(action.payload);
      return { ...state, language: action.payload };
    default:
      return state;
  }
};
